import { render, staticRenderFns } from "./WinLosePage.vue?vue&type=template&id=3a926f30&scoped=true"
import script from "./WinLosePage.vue?vue&type=script&lang=ts"
export * from "./WinLosePage.vue?vue&type=script&lang=ts"
import style0 from "./WinLosePage.vue?vue&type=style&index=0&id=3a926f30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a926f30",
  null
  
)

export default component.exports